/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import SStyles from '../styles';
import styles from './styles';
import { useAppConfig } from '../hooks/useAppConfig';

interface Col {
  text: string;
  selected?: boolean;
}

interface IProps {
  cols: Col[];
  activeIndex: number;
}

export default (props: IProps) => {
  const { cols, activeIndex } = props;
  const { style } = useAppConfig();

  return (
    <div css={css(SStyles.row, styles.rowWrap)}>
      {cols.map((c, i) => {
        return (
          <div
            key={i}
            css={css(
              SStyles.row,
              styles.row,
              (activeIndex >= i || c.selected) && styles.activeRow({ ...style })
            )}
          >
            <div className={'bubble'} css={css(styles.numberCircle)}>
              {i + 1}
            </div>
            <div>{c.text}</div>
            {i !== cols.length - 1 && <div css={css(styles.divider)} />}
          </div>
        );
      })}
    </div>
  );
}
